<template>
  <header class="header">
    <div class="header-bar">
      <router-link :to="{ path: '/' }">
        <div class="logo">
          Nude på
          <br />
          nätet
        </div>
      </router-link>
      <div class="contact-menu-button" @click="contactMenuToggle">
        <div class="inner-button">
          <img v-if="showContactMenu" src="@/assets/svg/menu-close.svg" />
          <img v-else src="@/assets/svg/contact-bubble.svg" />
        </div>
      </div>
    </div>
    <transition name="slide-down" mode="out-in">
      <div v-if="showContactMenu" class="contact-menu">
        <div class="inner">
          <g-title color="white" tag="h1" size="l">
            {{ contactOverlay.Title }}
          </g-title>
          <g-markdown :content="contactOverlay.Text" />
          <a
            v-for="(button, index) in contactOverlay.Buttons"
            :key="index"
            target="_blank"
            :href="button.Link"
          >
            <g-button color="white">{{ button.Label }}</g-button>
          </a>
        </div>
      </div>
    </transition>
  </header>
</template>

<script>
import GET_CONTACT_OVERLAY from '@/graphql/GetContactOverlay.gql';

export default {
  data() {
    return {
      showContactMenu: false,
      contactOverlay: {
        Title: '',
        Text: '',
        Buttons: []
      }
    };
  },
  apollo: {
    contactOverlay: {
      query: GET_CONTACT_OVERLAY
    }
  },
  methods: {
    contactMenuToggle() {
      this.showContactMenu = !this.showContactMenu;
    }
  }
};
</script>

<style lang="scss" scoped>
.header {
  position: sticky;
  top: 0;
  z-index: 10;
}

.header-bar {
  align-items: flex-start;
  background-image: url('~@/assets/svg/header-bg.svg');
  background-position: 0% 0%;
  background-repeat: no-repeat;
  display: flex;
  height: 70px;
  justify-content: space-between;
  position: relative;
  z-index: 10;
}

.logo {
  //background-color: $green;
  color: $white;
  font-family: Fugaz One;
  font-size: 18px;
  font-style: normal;
  font-weight: normal;
  letter-spacing: -0.04em;
  line-height: 104%;
  padding: 15px;
  text-transform: uppercase;
}

.contact-menu-button {
  padding: 10px;

  .inner-button {
    align-items: center;
    background-color: $green;
    background-color: #256a52;
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    height: 44px;
    justify-content: center;
    padding: 10px;

    width: 44px;
  }
}

.contact-menu {
  background-image: url('~@/assets/svg/contact-menu-bg.svg');
  background-position: 50% 100%;
  background-repeat: no-repeat;
  background-size: 768px 679px;
  color: $white;

  position: absolute;
  top: 0;
  width: 100%;

  .inner {
    margin: auto;
    max-width: $content-max-width;
    padding: 100px 25px 70px;
  }
}

.slide-down-enter-active,
.slide-down-leave-active {
  transition: transform 0.3s;
}

.slide-down-enter,
.slide-down-leave-to /* .fade-leave-active below version 2.1.8 */ {
  transform: translateY(-100%);
}

@media screen AND (min-width: $medium-screen) {
  .logo {
    font-size: 34px;
    padding: 20px;
  }

  .header-bar {
    background-size: auto 220%;
    height: 110px;
  }

  .contact-menu-button {
    margin: 5px;

    .inner-button {
      height: 54px;
      width: 54px;

      img {
        width: 90%;
      }
    }
  }
}
</style>
